import { apiRequest } from './client';
import type { BuffBonuses } from '../utils/itemStats';
import type { CharacterEffect, EffectTriggerResult, Game, GameCreatePayload, GameOverview } from '../types';

export function fetchGames() {
  return apiRequest<Game[]>('/api/games');
}

export function createGame(payload: GameCreatePayload) {
  return apiRequest<Game>('/api/games', { method: 'POST', body: payload });
}

export function deleteGame(id: number) {
  return apiRequest<unknown>(`/api/games/${id}`, { method: 'DELETE' });
}

export function setCharacterHealth(characterId: number, health: number) {
  return apiRequest<unknown>(`/api/characters/${characterId}/set-health-mana`, {
    method: 'PUT',
    auth: true,
    body: { health },
  });
}

export function createCharacterBuff(
  characterId: number,
  payload: { name: string; bonuses?: BuffBonuses; description?: string; effect?: string; icon_url?: string | null },
) {
  return apiRequest<{ message: string; effect: CharacterEffect; effects: CharacterEffect[] }>(
    `/api/characters/${characterId}/effects`,
    { method: 'POST', auth: true, body: payload },
  );
}

export function repairCharacterArmor(characterId: number, characterItemId: number) {
  return apiRequest<{ message: string; item: { name: string; armor_remaining?: number | null } }>(
    `/api/characters/${characterId}/items/${characterItemId}/repair`,
    { method: 'POST', auth: true },
  );
}

export function revokeCharacterEffect(characterId: number, effectId: number) {
  return apiRequest<{ message: string; effects: CharacterEffect[] }>(
    `/api/characters/${characterId}/effects/${effectId}`,
    { method: 'DELETE', auth: true },
  );
}

export function triggerCharacterEffect(characterId: number, effectId: number) {
  return apiRequest<EffectTriggerResult>(
    `/api/characters/${characterId}/effects/${effectId}/trigger`,
    { method: 'POST', auth: true },
  );
}

export function fetchGameOverview(gameId: number) {
  return apiRequest<GameOverview>(`/api/games/${gameId}/overview`);
}
